(ns frontend.view.task.webentry-resolution.view
  (:require
   [common.localization :as loc]
   [common.sync-progress :as sync-progress]
   [frontend.page-components.default-page-layout :as default-page-layout]
   [frontend.page-components.zap-toolbar :as zap-toolbar]
   [frontend.routing :as routing]
   [frontend.state.current-session :as session]
   [frontend.view.entity-viewers.scope :as scope]
   [frontend.view.not-found :as not-found]
   [frontend.view.syncing-data :as sync]
   [frontend.view.task.webentry-resolution.asset :as asset]
   [frontend.view.task.webentry-resolution.components :as components]
   [frontend.view.task.webentry-resolution.contacts :as contacts]
   [frontend.view.task.webentry-resolution.db :as db]
   [frontend.view.task.webentry-resolution.deal :as deal]
   [frontend.view.task.webentry-resolution.events :as events]
   [reagent.core :as r]
   [ui.components.breadcrumbs.view :as breadcrumbs]
   ))

;; used to force figwheel update:
(defonce tmp (r/atom {:c 0}))
(defonce drag-state (r/atom {}))

(defn toolbar-buttons
  [{:keys [task]}]
  [{:toolbar-button?  true
    :dropdown-action? false
    :ord              5
    :primary-button?  true
    :custom-style     "zap-btn__solid__salmon"
    :on-select        (fn []
                        (events/start-delete-task! @task))
    :label            (loc/tr :delete-task)}
   {:toolbar-button?  true
    :dropdown-action? false
    :ord              6
    :primary-button   true
    :label            (loc/tr :reassign-task)
    :on-select        (fn []
                        (events/start-reassign-task! @task))}])

(defn breadcrumbs
  [{:keys [webentry]}]
  [breadcrumbs/container
   [breadcrumbs/item
    {:on-click (fn []
                 (routing/set-view! [:tasks-grid]))}
    (loc/tr :webentry-tasks)]
   [breadcrumbs/item
    {:active? true}
    (:webentry/display-name @webentry)]])

(defn resolve-view
  [{:keys [task-id]}]
  (let [state db/state
        _ (swap! state assoc :task-id task-id)
        ;;note: create-signals! depends on :task-id in state being set:
        {:keys [webentry current-view task no-task?] :as signals} (events/create-signals state)]
    (swap! state assoc :current-view (events/start-view signals))
    (r/create-class
     {:component-will-unmount
      (fn [_]
        (reset! drag-state {})
        (reset! state {}))
      :reagent-render
      (fn [{:keys [_task-id]}]
        (let [current-view @current-view]
          (if @no-task?
            [not-found/not-found-content]
            [:<>
             (when-not (session/is-guest?)
               [zap-toolbar/view state (partial breadcrumbs {:webentry webentry})
                nil (toolbar-buttons {:task task})])
             ;; Invisible trackers. They load the entities that the resolution
             ;; references and the existing records that match the submission,
             ;; so a new-grid account sees them. They render nothing.
             [events/resolved-refs-hydrator signals]
             [events/webentry-matcher signals]
             [:div
              [:div
               {:class "flex h-[calc(100vh-183px)] overflow-auto"}
               [components/notification-view signals]
               (case current-view
                 :asset [asset/view drag-state signals]
                 :contacts [contacts/view drag-state signals]
                 :deal [deal/view drag-state signals]
                 [:div "error resolving view"])]
              [components/footer-toolbar signals]]])))})))

(defmethod routing/render-view :task-resolve/webentry
  [{:keys [route-params _view-params]}]
  (let [route-param-id (-> route-params
                           :id)
        task-id (if (= "testing" route-param-id)
                  "testing"
                  (-> route-params
                      :id
                      js/parseInt))]
    ;;the key change forces re-mounting of the component (and its child components)
    [default-page-layout/view
     ^{:key (str "webentry-task-resolve-id-" task-id)}
     [sync/wait-until-sync-progress sync-progress/COMPLETE
      ;; The page reads the task and its neighbors from the session. A new-grid
      ;; account does not get them from the sync. Hold a scope on the task.
      [scope/host
       {:entity-id    task-id
        :instance-id  :task-resolve
        :enabled?     (session/new-grid-2023?)
        :loading-view [sync/view]}
       [resolve-view {:task-id task-id}]]]]))
